import { useLocation } from "@tanstack/react-router";
import { useMemo, useState } from "react";
import { NotificationPanel } from "./NotificationPanel";
import { Bell } from "lucide-react";
import useGeneralNotification from "../patients/hooks/useNotifcation";
import { useAuth } from "../../context/AuthContext";

const ROUTE_TITLES: { [key: string]: string } = {
  "/clinic/dashboard": "Overview",
  "/admin/dashboard": "Overview",
  "/clinic/appointments": "Appointments",
  "/admin/appointments": "Appointments",
  "/clinic/doctors": "Doctors",
  "/admin/doctors": "Doctors",
  "/clinic/patients": "Patients",
  "/admin/patients": "Patients",
  "/clinic/report": "Reports",
  "/admin/report": "Reports",
  "/admin/supervisors": "Clinic Supervisor",
  "/admin/medicalcamp": "Medical Camp",
  "/clinic/settings": "Settings",
  "/admin/settings": "Settings",
  "/admin/clinics": "Clinics",
  "/admin/video-blogs": "Video Blogs",
  "/admin/stocks-orders/delivery-boys": "Driver List",
  "/admin/stocks-orders/dashboard": "Stocks Dashboard",
  "/admin/stocks-orders/orders": "Manage Orders",
  "/admin/stocks-orders/labtest-orders": "Labtest Orders",
  "/admin/stocks-orders/offline-labtest-orders": "Offline Labtest Orders",
  "/admin/stocks-orders/inventory-management": "Inventory Management",
  "/admin/stocks-orders/categories": "Categories",
  "/admin/stocks-orders/products": "Products",
  "/admin/stocks-orders/lab-tests": "Lab Tests",
  "/admin/stocks-orders/medicine": "Medicine",
  "/admin/stocks-orders/items": "Add New Items",
  "/admin/stocks-orders/promotions": "Promotions",
  "/clinic/stocks-orders/dashboard": "Orders Dashboard",
  "/clinic/stocks-orders/orders": "Orders",
  "/clinic/stocks-orders/online-orders": "Online Orders",
  "/clinic/stocks-orders/offline-orders": "Offline Orders",
  "/clinic/stocks-orders/labtest-orders": "Labtest Orders",
  "/clinic/stocks-orders/offline-labtest-orders": "Offline Labtest Orders",
  "/clinic/stocks-orders/products": "Products",
  "/clinic/stocks-orders/lab-tests": "Lab Tests",
  "/clinic/stocks-orders/delivery-boys": "Delivery Boys",
  "/clinic/reports/medicine-order": "Medicine Order",
  "/clinic/reports/labtest-order": "Labtest Order",
  "/clinic/reports/appointment": "Appointment",
  "/admin/reports/medicine-order": "Medicine Order Report",
  "/admin/reports/labtest-order": "Labtest Order Report",
  "/admin/reports/appointment": "Appointment Report",
  "/admin/appointments/overview": "Appointment Overview",
  "/clinic/appointments/overview": "Appointment Overview",
  "/medicalcamp/appointments/overview": "Appointment Overview",
  "/clinic/appointments/:id": "Appointment Details",
  "/medicalcamp/appointments/:id": "Appointment Details",
  "/admin/appointments/:id": "Appointment Details",
};

export function TopBar() {
  const { user } = useAuth();
  const location = useLocation();
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const { notifications } = useGeneralNotification({
    toId: String(user?.id),
    notify: false,
  });
  const pageTitle = useMemo(() => {
  const currentPath = location.pathname;

  if (currentPath.startsWith("/clinic/appointments/")) {
    return "Appointment Details";
  }
  if (currentPath.startsWith("/admin/appointments/")) {
    return "Appointment Details";
  }
  if (currentPath.startsWith("/medicalcamp/appointments/")) {
    return "Appointment Details";
  }

  return ROUTE_TITLES[currentPath] || "Dashboard";
}, [location.pathname]);

  const unreadNotificationLength = notifications.filter(
    (noti) => noti.status !== "Read"
  ).length;

  return (
    <header className="bg-white border-b h-16 flex items-center px-8 justify-between">
      <div className="text-xl font-semibold text-gray-900">{pageTitle}</div>

      <div className="flex items-center gap-4">
        <div className="relative">
          <button
            onClick={() => setIsNotificationOpen(!isNotificationOpen)}
            className="relative"
          >
            <Bell className="w-5 h-5 text-gray-600 hover:text-gray-900" />
            {unreadNotificationLength > 0 && (
              <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center">
                {unreadNotificationLength}
              </span>
            )}
          </button>
        </div>
      </div>

      <NotificationPanel
        isOpen={isNotificationOpen}
        onClose={() => setIsNotificationOpen(false)}
      />
    </header>
  );
}
